/**
 * Convert an internal Kerio backplane hostname to the public client hostname.
 * Example: kerio-int.datacenterwest.com → kerio.datacenterwest.com
 */
export function toPublicKerioHost(host) {
    return host
        .trim()
        .replace(/^https?:\/\//i, "")
        .replace(/\/+$/, "")
        .replace(/^([^.]+)-int\./i, "$1.");
}
/**
 * Build Kerio Connect CalDAV/CardDAV URLs from the paired host and mailbox email.
 * Internal *-int.* hosts are rewritten to the public hostname for client use.
 * @see https://support.kerioconnect.gfi.com/article/115733
 */
export function buildKerioDavUrls(host, email) {
    const normalizedHost = toPublicKerioHost(host);
    if (!normalizedHost) {
        throw new Error("Kerio mail server host is missing");
    }
    const normalizedEmail = email.trim().toLowerCase();
    const at = normalizedEmail.lastIndexOf("@");
    if (at <= 0 || at === normalizedEmail.length - 1) {
        throw new Error("A full email address is required for CalDAV/CardDAV URLs");
    }
    const localPart = normalizedEmail.slice(0, at);
    const domain = normalizedEmail.slice(at + 1);
    const base = `https://${normalizedHost}`;
    return {
        host: normalizedHost,
        username: normalizedEmail,
        localPart,
        domain,
        caldav: `${base}/caldav/users/${domain}/${localPart}`,
        caldavThunderbird: `${base}/calendars/${domain}/${localPart}/`,
        carddav: `${base}/carddav/users/${domain}/${localPart}`,
    };
}
